import { noop } from 'rxjs';
import { Style } from '../../helpers/style/style';
import { NULL_SERVICE, Service } from '../base/service';

export interface StyleService extends Service {
  readonly style: Style;

  applyStyle(style: Style): void;
  resetStyle(): void;
}

export const NULL_STYLE_SERVICE: StyleService = {
  ...NULL_SERVICE,
  style: {},
  applyStyle: noop,
  resetStyle: noop,
};
